<script setup>
import { computed } from 'vue';
import UiBadge from './UiBadge.vue';

// A row of badges (tags, people, subjects). With `max`, the rest collapse
// into "+N"; the full list shows in its tooltip.
const props = defineProps({
  items: { type: Array, default: () => [] },
  // Field holding the label when items are objects
  itemTitle: { type: String, default: 'name' },
  max: { type: Number, default: 0 },
  variant: { type: String, default: 'secondary' },
  empty: { type: String, default: '—' },
});

const label = (item) => (typeof item === 'object' && item ? item[props.itemTitle] : item);
const shown = computed(() => (props.max ? props.items.slice(0, props.max) : props.items));
const hidden = computed(() => props.items.length - shown.value.length);
const allLabels = computed(() => props.items.map(label).join(', '));
</script>

<template>
  <span v-if="items.length" class="ui-badge-list">
    <UiBadge v-for="(item, i) in shown" :key="i" :variant="variant">{{ label(item) }}</UiBadge>
    <UiBadge v-if="hidden > 0" variant="outline" :title="allLabels">+{{ hidden }}</UiBadge>
  </span>
  <span v-else class="ui-badge-list__empty">{{ empty }}</span>
</template>

<style scoped>
.ui-badge-list {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px 0;
}
.ui-badge-list__empty {
  color: var(--muted-foreground);
}
</style>
